module.exports = __webpack_public_path__ + "assets/4c64ae66e2910b94295880bc3ec96145.png";